// @flow
import type { Element } from 'react';

import React from 'react';
import { FormGroup, Col, Row } from 'reactstrap';
import {
  NUMBER_OF_STORIES,
  NUMBER_OF_SUBGRADE_STORIES,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import FieldVisibilityToggle from '#components/pages/Models/Model/sections/support/forms/FieldVisibilityToggle/index.js';
import {
  Field,
  Fieldset,
  FormGroupRow,
} from '#components/pages/Models/Model/support/form/index.js';
import { FieldFeedback } from '#components/support/forms/utility/index.js';
import NumberOfStoriesWarning from './NumberOfStoriesWarning/index.js';

type Props = {|
  form: string,
  showSubgradeStories: boolean,
|};

const StoriesFieldSet = ({ form, showSubgradeStories }: Props): Element<typeof Fieldset> => {
  const { fieldsByName } = modelTypesByForm[form];
  return (
    <Fieldset>
      <legend>Stories</legend>
      <Row>
        <Col>
          <FieldVisibilityToggle
            className="float-right define-subgrade-toggle"
            form={form}
            on={showSubgradeStories}
            onFields={[NUMBER_OF_SUBGRADE_STORIES]}
            onText="Superstructure Only"
            offFields={[]}
            offText="Include Subgrade"
          />
        </Col>
      </Row>
      <Row className="mt-0">
        <Col lg="4">
          <FormGroup className="mt-0">
            <Field field={fieldsByName[NUMBER_OF_STORIES]} excludeFeedback />
          </FormGroup>
        </Col>
      </Row>
      <Row className="mt-n3 mb-3">
        <Col lg="12">
          {/* FieldFeedback moved for better wrapping */}
          <FieldFeedback name={NUMBER_OF_STORIES} form={form} />
          <NumberOfStoriesWarning form={form} />
        </Col>
      </Row>
      <FormGroupRow form={form} fields={[NUMBER_OF_SUBGRADE_STORIES]}>
        <Col lg="4">
          <FormGroup form={form} fields={[NUMBER_OF_SUBGRADE_STORIES]}>
            <Field field={fieldsByName[NUMBER_OF_SUBGRADE_STORIES]} />
          </FormGroup>
        </Col>
      </FormGroupRow>
    </Fieldset>
  );
};

export default StoriesFieldSet;
